import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../store/rootReducer';
import { setLegalCheck } from '../../../../../../store/influencer/contractInfluencerSlice';
import { downloadFile } from '../../../../../../shared/functions/Functions';
import FilePlaceholder from '../../../../../../shared/components/placeholder/FilePlaceholder';
import { Fancybox } from '../../../../../../shared/components/Fancybox';
import PayoutSectionOverview from '../../../../../brand/campaign/briefing/components/shared/PayoutSectionOverview';
import DOMPurify from 'dompurify';

export function ContractLegalTab() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { campaign, isLegalChecked, requiredFieldChangeColor } = useSelector(
        (state: IAllStates) => state.contractInfluencer
    );
    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        dispatch(setLegalCheck(checked));
    };

    return (
        <Row>
            <PayoutSectionOverview
                isLongTerm={campaign?.isLongTerm}
                paymentTerms={campaign?.paymentTerms}
                invoicePeriod={campaign?.invoicePeriod}
                paymentTermsCustom={campaign?.paymentTermsCustom}
            />
            <Col xs={12}>
                <h6 className="text-muted">{t('influencer.offer_management.modal.exclusivity')}</h6>
                <p className="mb-4">{campaign?.exclusivityDescription ?? '-'}</p>
            </Col>
            <Col xs={12}>
                <h6 className="text-muted">{t('influencer.offer_management.modal.exc_duration')}</h6>
                <p>
                    {campaign?.exclusivityDuration
                        ? t(`brand.campaign.briefing.step8.${campaign?.exclusivityDuration}`)
                        : '-'}
                </p>
            </Col>
            <Col xs={12}>
                <h6 className="text-muted">{t('influencer.briefing_detail.competitors')}</h6>
                <p>
                    {campaign?.exclusivityCompetitors?.length
                        ? campaign?.exclusivityCompetitors?.map((competitor, index) => (
                              <span key={competitor?.id}>
                                  {competitor?.description}
                                  {campaign?.exclusivityCompetitors?.length - 1 > index ? ', ' : ''}
                              </span>
                          ))
                        : '-'}
                </p>
            </Col>
            {campaign?.hasByLaws && (
                <>
                    <Col className="mt-4" xs={12}>
                        <h6 className="text-muted">{t('influencer.offer_management.modal.bylaws')}</h6>
                        <div
                            className="remove-html-styling"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(campaign?.byLawsExplanation ?? '-', { ADD_ATTR: ['target'] }),
                            }}
                        ></div>
                    </Col>
                    <Col xs={12}>
                        <h6 className="text-muted">{t('influencer.offer_management.modal.bylaws_uploads')}</h6>
                    </Col>
                    <Fancybox>
                        <div className="row">
                            {!!campaign?.bylaws?.length ? (
                                campaign?.bylaws?.map(bylaws => {
                                    return (
                                        <div className="col-md-3 my-2 pl-3 position-relative" key={bylaws?.id}>
                                            <FilePlaceholder
                                                file={bylaws}
                                                styleContent={{ height: 130 }}
                                                handleDownload={() => downloadFile(bylaws?.path, bylaws?.title)}
                                            />
                                        </div>
                                    );
                                })
                            ) : (
                                <Col>-</Col>
                            )}
                        </div>
                    </Fancybox>
                </>
            )}
            <Col className="d-flex align-items-center" xs={12}>
                <Checkbox
                    className="mb-0"
                    id="checkbox"
                    onChange={changeHandler}
                    color="primary"
                    checked={isLegalChecked}
                />
                <label
                    htmlFor="checkbox"
                    className={`cursor-pointer mb-0 ${requiredFieldChangeColor ? 'text-danger' : 'text-muted'}`}
                    dangerouslySetInnerHTML={{ __html: t('auth.register.brand.step1.terms') }}
                />
            </Col>
        </Row>
    );
}
